import { combineReducers } from "redux";

import files from '../modules/files/reducer.js';

export default combineReducers({
  files,
})
